module.exports = __webpack_public_path__ + "media/svg/company_light_vertical-655d61e5.svg";